import { render, staticRenderFns } from "./add_file.vue?vue&type=template&id=84da6992&scoped=true&"
import script from "./add_file.vue?vue&type=script&lang=js&"
export * from "./add_file.vue?vue&type=script&lang=js&"
import style0 from "./add_file.vue?vue&type=style&index=0&id=84da6992&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84da6992",
  null
  
)

export default component.exports